import { useServicesContext } from "@modules/core/services/services.context"
import { ExerciseScoreCategory, ExerciseScoreDifficulty } from "@modules/sessionBlock/exercises/exerciseTypes"
import { useQuery } from "@tanstack/react-query"

export const useScoreboard = (
  programId: string,
  sessionId: string,
  exerciseId: string | undefined,
  difficulty: ExerciseScoreDifficulty | undefined,
  category: ExerciseScoreCategory,
  referenceDate: string,
  page?: number,
) => {
  const { scoreboardService } = useServicesContext()

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["scoreboard", programId, sessionId, exerciseId, difficulty, category, referenceDate, page],
    queryFn: async () => {
      if (exerciseId)
        return await scoreboardService.getScoreboard(
          programId,
          sessionId,
          exerciseId,
          difficulty,
          category,
          referenceDate,
        )
      else return undefined
    },
    enabled: exerciseId !== undefined,
  })

  return { data, isLoading, error, refetch }
}

export const useMyRanking = (
  programId: string,
  sessionId: string,
  exerciseId: string | undefined,
  difficulty: ExerciseScoreDifficulty | undefined,
  category: ExerciseScoreCategory,
  referenceDate: string,
) => {
  const { scoreboardService } = useServicesContext()

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["myRanking", programId, sessionId, exerciseId, difficulty, category, referenceDate],
    queryFn: async () => {
      if (exerciseId && difficulty)
        return await scoreboardService.getRanking(programId, sessionId, exerciseId, difficulty, category, referenceDate)
      else return undefined
    },
    enabled: exerciseId !== undefined && difficulty !== undefined,
  })

  return { data, isLoading, error, refetch }
}
